import ManpowerGrowth from "./cartGrowth.jsx";
import QtyMechanicByArea from "./qtyMechanicByArea.jsx";
import QtyMechanicAll from "./qtyMechanicAll.jsx";
import { useEffect, useState } from "react";
import QtyMechanicByGrade from "./qtyMechByGrade.jsx";
import QtyMechanicBySpcl from "./qtyMechBySpcl.jsx";
import { dashboardMechanicTotal } from "../../config/apiSPA.js";
function MechanicResume() {
  const [qtyMechAll, setQtyMechAll] = useState([]);
  const [qtyByArea, setQtyByArea] = useState([]);
  const [qtyByGrade, setQtyByGrade] = useState([]);
  const [qtyBySpcl, setQtyBySpcl] = useState([]);
  useEffect(() => {
    dashboardMechanicTotal().then((res) => {
      setQtyMechAll(res);
      setQtyByArea(res.byArea);
      setQtyByGrade(res.byGrade);
      setQtyBySpcl(res.bySpcl);
    });
  }, []);
  return (
    <>
      <div className="row">
        <div className="col-lg-4">
          <QtyMechanicAll data={qtyMechAll} />
          <QtyMechanicByArea data={qtyByArea} />
        </div>
        <div className="col-lg-8">
          <div className="row">
            <div className="col-lg-6">
              <QtyMechanicBySpcl data={qtyBySpcl} />
            </div>
            <div className="col-lg-6">
              <QtyMechanicByGrade data={qtyByGrade} />
            </div>
            <div className="col-lg-12 mt-3">
              <ManpowerGrowth />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default MechanicResume;
